import { render, staticRenderFns } from "./productsForm.vue?vue&type=template&id=80c523f4&"
import script from "./productsForm.vue?vue&type=script&lang=js&"
export * from "./productsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports